import { Component } from '@angular/core';
import {NotificationService} from "../../services/notification/notification.service";

@Component({
  selector: 'app-mes-courriers',
  templateUrl: './mes-courriers.component.html',
  styleUrls: ['./mes-courriers.component.scss']
})
export class MesCourriersComponent {
  constructor(protected notificationService: NotificationService) {
  }

  handleUpdateStatusEvent(_event: any) {
    const count: number = this.notificationService.countGedNotificationSubject.getValue();
    if (_event && count > 0) {
      this.notificationService.countGedNotificationSubject.next(count - 1);
    }
  }

  handleEmitUnreadNotificationsEvent(_event: any) {
    this.notificationService.countGedNotificationSubject.next(_event ? _event : 0);
  }
}
